"use client"
import React, { useMemo, useState } from "react"
import styles from "@css/modules/Blogs.module.scss"
import Link from "next/link"
import Image from "next/image"
import { AllArticles } from "./components/AllArticles"
import { Search } from "@css/icons/Search"

export function BlogContent({ data, blogs }) {
    const [query, updateQuery] = useState("")
    const img = data?.preview_img
    //const currentDate = useMemo(() => getBlogDate(data.current_blog?.publishedAt), [data.current_blog?.publishedAt])
    const currentUrl = "/blog/" + data.current_blog?.slug
    const blogPosts = useMemo(() => {
        const currentId = data.current_blog?.id
        let _blogs = blogs.filter((i) => currentId !== i.id)
        if (query) {
            _blogs = _blogs.filter((i) => (i.title || "").includes(query) || (i.short_description || "").includes(query) || (i.blog_tags || []).find((j) => j.name.includes(query)))
        }
        return _blogs
    }, [query, blogs, data.current_blog?.id])
    const currentBlog = (
        <div className={styles.currentBlogWrapper}>
            <h2 className={styles.blogTitleMobile}>{data.sub_title}</h2>
            {img && (
                <Link href={currentUrl}>
                    <Image className={styles.currentBlogImage} src={img.url} alt={img.alternativeText} width={img.width} height={img.height} />
                </Link>
            )}
            <div className={styles.currentBlog}>
                <h2 className={styles.currentBlogTitle}>{data.sub_title}</h2>
                {/*
                <span className={styles.currentBlogPublish}>{currentDate}</span>
*/}
                <Link href={currentUrl}>
                    <h3 className={styles.currentBlogSub}>{data.current_blog?.title}</h3>
                </Link>
                <div className={styles.currentBlogDesc}>{data.current_blog?.short_description}</div>
            </div>
        </div>
    )

    return (
        <div className={styles.root}>
            <div className={styles.head}>
                <h1>{data.title}</h1>
                <div className={styles.searchWrapper}>
                    <input
                        name="search"
                        id="search"
                        autoComplete="off"
                        onChange={(event) => updateQuery(event.target.value)}
                        className={styles.searchInp}
                        placeholder={data.search_input_text}
                    />
                    <label htmlFor="search" className={styles.searchIcon}>
                        <Search />
                    </label>
                </div>
            </div>
            {currentBlog}
            <AllArticles blogs={blogPosts} search={!!query} />
        </div>
    )
}
